import userService from '../services/userService';
import { UserAction } from '../types/UserAction';
import { UserData } from '../types/ContentData';

const usersList = () => (dispatch: any) => {
	const success = (data: UserData[]): UserAction =>
		({ type: 'USER_SUCCESS', data });
	const failure = (error: string): UserAction =>
		({ type: 'USER_FAILED', error });

	userService.fetchUsersList()
		.then(
			(res: any) => { dispatch(success(res)) },
			err => { dispatch(failure(err)) }
		);
}

export {
	usersList,
};